module.exports = __webpack_public_path__ + "static/media/about.d35925a3.jpg";